module.exports = __webpack_public_path__ + "img/logo-full.102cda51.png";